<template>
    <RecycleScroller :items="items" :item-size="22" key-field="index" v-slot="{item}" :style="{height: height+'px'}">
        <UploadItem :item="item" :percent="100" :stats="status"/>
    </RecycleScroller>
</template>

<script>
    import {RecycleScroller} from "vue-virtual-scroller";
    import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
    import UploadItem from "./UploadItem";

    export default {
        name: "UploadItems",
        props: {
            items: Array,
            height: Number,
            status: String,
        },
        components: {UploadItem, RecycleScroller},
    }
</script>
